import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LocalisationService } from 'src/app/localisation.service';
import { MatchTeam } from 'src/app/match-team.model';
import { Sport } from 'src/app/sport.model';
import { SPORTS } from 'src/app/sports';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-team-icon',
  templateUrl: './team-icon.component.html',
  styleUrls: ['./team-icon.component.scss']
})
export class TeamIconComponent implements OnChanges {
  @Input() sportCode: String;
  @Input() team: MatchTeam;
  sport: Sport;
  environment = environment;
  constructor(
    private localisationService: LocalisationService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(changes).includes("sportCode")) {
      const sportCodeChange = changes["sportCode"];
    
      if (this.localisationService.sportPrioritySort(SPORTS).some(s => s.code === sportCodeChange.currentValue)) {
        this.sport = SPORTS.find(s => s.code === sportCodeChange.currentValue);
      } else {
        console.warn(`TeamIconComponent constructor failed - sport code ${sportCodeChange.currentValue} not found`);
      }
    }
  }

}
